/*
  Annoucements/Notifications for the dashboard.
*/

import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { type INotificationData, NotificationSeverity } from '../../models/notification-data';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';
import { NotificationDataService } from '../../services/notification-data.service';

@Component({
  standalone: false,
  selector: 'odin-announcement-display',
  templateUrl: './announcement-display.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./announcement-display.component.scss'],
})
export class AnnouncementDisplayComponent {

  readonly messages$: Observable<INotificationData[]> =
    this.notificationDataService.getNotifications();

  constructor(
    private readonly router: Router,
    private readonly notificationDataService: NotificationDataService
  ) {}

  getIcon(severity: NotificationSeverity): IconDefinition {
    switch (severity) {
      case NotificationSeverity.Info:
        return faInfoCircle;
      case NotificationSeverity.Warning:
        return faExclamationTriangle;
      case NotificationSeverity.Critical:
        return faExclamationCircle;
      default:
        return faInfoCircle;
    }
  }

  viewMore(): void {
    this.router.navigate(['/notifications']);
  }
}